module.exports = {"131102001":"河西街道","131102002":"河东街道","131102003":"路北街道","131102004":"中华大街街道","131102100":"郑家河沿镇","131102101":"赵家圈镇","131102102":"邓庄镇","131102200":"何家庄乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/131102.json
// module id = 330
// module chunks = 0